import i18n from '@/i18n'

export class Utile {
  static combin (array, size, start, init, output) {
    if (init.length >= size) {
      output.push(init)
    } else {
      for (let i = start; i < array.length; i++) {
        Utile.combin(array, size, i + 1, init.concat(array[i]), output)
      }
    }
    return output
  }
  static all (array, size) {
    return Utile.combin(array, size, 0, [], [])
  }
  /** 阵列切割 (arr: Array<any>, size: number): Array<any> */
  static chunk (arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
  }
  static dig (obj, target) {
    if (obj == null) return
    return target in obj
      ? obj[target]
      : Object.values(obj).reduce((acc, val) => {
        if (acc !== undefined) return acc;
        if (typeof val === 'object' && obj != null) return this.dig(val, target)
      }, undefined)
  }
  static ArrayRange (end, start = 0, step = 1, type = "") {
    return Array.from({ length: Math.ceil((end + 1 - start) / step) })
      .map((v, i, arr) => (arr.length - i - 1) * step + start + type)
  }
}
export const ToDecimal = function (num, index = 2) {
  if (isNaN(num)) return
  let newnum = num.toString()
  newnum.indexOf('-') != -1 ? newnum.replace('-') : ''
  const snum = newnum.split('.')
  let buz = ''
  if (snum[1] == undefined) {
    buz = '00'
  } else {
    let arr = snum[1].split("")
    for (let i = 0; i < index; i++) {
      buz += arr[i] ? arr[i] : '0'
    }
  }
  return snum[0] + '.' + buz
}
export const cFormat = function (value) {
  const number = Number.parseInt(value)
  if (typeof number === 'number' && !isNaN(number)) {
    return value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
      return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
    })
  } else {
    return value
  }
}
export class accNum {
  static accSub (value1, value2) {
    let r1, r2, m, n;
    try { r1 = value1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = value2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return ((value1 * m - value2 * m) / m).toFixed(n);
  }
  static accMul (arg1, arg2) {
    let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try { m += s1.split(".")[1].length } catch (e) { }
    try { m += s2.split(".")[1].length } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
  }
  static accCheck (value) {
    let regPos = /(^[\-0-9][0-9]*(.[0-9]+)?)$/; //判断是否是数字。
    let checkNum = regPos.test(value)
    return checkNum;
  }
  static accPlusInt (value) {
    let regPos = /(^[1-9]*([0-9]+)?)$/; //判断是否是一個大於0的整数。
    let checkNum = regPos.test(value)
    return checkNum;
  }
}
export class KeyControlName {
  static SmallAndBig (t = '') {
    return {
      '0': '和',
      '1': `${t}大`,
      '2': `${t}小`
    }
  }
  static SixmarkSmallAndBig (t = '') {
    return {
      '0': '和',
      '1': `${t}小`,
      '2': `${t}大`
    }
  }
  static SingleAnddouble (t = '') {
    return {
      '0': '和',
      '1': `${t}单`,
      '2': `${t}双`
    }
  }
  static dt () {
    return {
      '0': '和',
      '1': '龙',
      '2': '虎'
    }
  }
  static agent () {
    return {
      '12': '豹子',
      '13': '顺子',
      '14': '对子',
      '15': '半顺',
      '16': '杂六'
    }
  }
  static Directions () {
    return {
      '1': '东',
      '2': '南',
      '3': '西',
      '4': '北'
    }
  }
  static Mahjongg () {
    return {
      '1': '中',
      '2': '发',
      '3': '白'
    }
  }
}

export const numberConvertToUppercase = function (num) { // 通道中文字
  const upperNumbers = [i18n.t("__betting.zero"), i18n.t("__betting.one"), i18n.t("__betting.two"), i18n.t("__betting.three"), i18n.t("__betting.four"), i18n.t("__betting.five"), i18n.t("__betting.six"), i18n.t("__betting.seven"), i18n.t("__betting.eight"), i18n.t("__betting.nine"), i18n.t("__betting.ten"), i18n.t("__betting.hundred"), i18n.t("__betting.thousand"), i18n.t("__betting.tenThousand"), i18n.t("__betting.billion")]
  const length = String(num).length
  if (length === 1) {
    return upperNumbers[num]
  } else if (length === 2) {
    if (num === 10) {
      return upperNumbers[num]
    } else if (num > 10 && num < 20) {
      const index = String(num)
      return i18n.t("__betting.ten") + upperNumbers[index.charAt(1)]
    } else {
      const index = String(num)
      return upperNumbers[index.charAt(0)] + i18n.t("__betting.ten") + upperNumbers[index.charAt(1)].replace(i18n.t("__betting.zero"), '')
    }
  } else {
    // TODO: 超出99暂不考虑
    return ''
  }
}
export class Random {
  // 不重複隨機選號
  // length: 號碼的長度
  // lengthNb: 預設產生幾號至幾號的號碼陣列
  static Number (length, lengthNb) {
    let array = []
    const random = Utile.ArrayRange(...lengthNb);
    for (let i = 0; i < length; i++) {
      let index = Math.floor(Math.random() * (random.length - i));
      array.push(random[index])
      random[index] = random[random.length - i - 1]
    }
    return array
  }
}

export class Handle {
  constructor (arr, name = 'oddname', sortname = 'odd') {
    this.arr = arr
    this.res = []
    this.obj = {}
    this.index = 0
    this.name = name
    this.sortname = sortname
  }
  array () {
    this.arr.forEach(val => {
      if (this.obj.hasOwnProperty(val[this.name])) {
        this.res[this.obj[val[this.name]]].items.push(val)
      } else {
        this.obj[val[this.name]] = this.index++
        this.res.push({
          id: val[this.name],
          items: [val]
        })
      }
    })
    return this.res
  }
  exgameList () {
    this.arr.forEach(val => {
      if (this.obj.hasOwnProperty(val[this.name])) {
        this.res[this.obj[val[this.name]]].items.push(val)
      } else {
        this.obj[val[this.name]] = this.index++
        this.res.push({
          id: val[this.name],
          catenaId: val.catenaId,
          items: [val]
        })
      }
    })
    return this.res
  }
  static newobj (array, title) {
    return array.map((it, i) => {
      return {
        id: title[i],
        items: it
      }
    })
  }
}